import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["icon", "showWrapper"];
import React from "react";
import { Flex } from "@catchoftheday/cg-components";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var PaymentIcon = function PaymentIcon(_ref) {
  var icon = _ref.icon,
      showWrapper = _ref.showWrapper,
      props = _objectWithoutProperties(_ref, _excluded);

  if (!showWrapper) return ___EmotionJSX(Flex, _extends({
    width: "50px",
    height: "30px",
    alignItems: "center",
    justifyContent: "center"
  }, props), /*#__PURE__*/React.cloneElement(icon, {
    width: "100%",
    height: "auto"
  }));
  return ___EmotionJSX(Flex, _extends({
    border: 1,
    width: "50px",
    height: "30px",
    alignItems: "center",
    justifyContent: "center",
    borderColor: "grey",
    borderRadius: "default"
  }, props), /*#__PURE__*/React.cloneElement(icon, {
    width: "25px",
    height: "auto"
  }));
};